import { render, staticRenderFns } from "./FormatOfClasses.vue?vue&type=template&id=0d2c6551&scoped=true&"
import script from "./FormatOfClasses.vue?vue&type=script&lang=js&"
export * from "./FormatOfClasses.vue?vue&type=script&lang=js&"
import style0 from "./FormatOfClasses.vue?vue&type=style&index=0&id=0d2c6551&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c6551",
  null
  
)

export default component.exports